module.exports = __webpack_public_path__ + "static/media/company-signup.4abdf0b0.svg";